import React from "react";
import {Tab, Tabs} from 'react-bootstrap';
import ContainerTitle from "../components/system/ContainerTitle";
import Comprehend from "../components/engines/comprehend/Index"
import Bert from "../components/engines/bert/Index"

export default function Engines() {
  const COMPREHEND = "Comprehend";
  const BERT = "Bert";

  return (
    <React.Fragment>
      <ContainerTitle title="Sentiment Analysis Engines" loading={false} />
      <Tabs defaultActiveKey={COMPREHEND}>
        <Tab eventKey={COMPREHEND} title={COMPREHEND}>
          <div className='mt-2'><Comprehend/></div>
        </Tab>
        <Tab eventKey={BERT} title={BERT}>
          <div className='mt-2'><Bert/></div>
        </Tab>
      </Tabs>
    </React.Fragment>
  );
}
